var MembershipAnswers = /** @class */ (function () {
    function MembershipAnswers() {
    }
    MembershipAnswers.fromResponse = function (res) {
        var answers = res.answers;
        return answers.reduce(function (mA, qA) {
            mA[qA.siteMemberId] = qA.questionAnswers;
            return mA;
        }, {});
    };
    return MembershipAnswers;
}());
export { MembershipAnswers };
//# sourceMappingURL=MembershipAnswers.js.map